<template>
  <Radio v-model="selected" :type="type" :style="editorStyle" :id="id">{{ innerText }}</Radio>
</template>
<script>
const component = {
  name: 'hex-radio',
  props: {
    type: String,
    shape: String,
    st: Object,
    innerText: String,
    id: String,
    selected: Boolean,
    label: String
  },
  data() {
    return {
      editorStyle: process.env.MODE === 'editor' ? this.st : {}
    }
  }
}
if (process.env.MODE === 'editor') {
  component.define = require('./define.js');
}
export default component
</script>



// WEBPACK FOOTER //
// index.vue?7951e770